module.exports = __webpack_public_path__ + "img/wanderSaneVlogs.c789a949.svg";